import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("feral_admin_token")}` } });

const Row = ({ label, value, onChange, placeholder, testid }) => (
  <label className="flex flex-wrap items-center gap-3 w-full">
    <span className="text-xs uppercase tracking-[0.12em] text-[#9a876f] w-44">{label}</span>
    <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="flex-1 min-w-[240px] border border-[#d9c3a8] rounded px-3 py-2 text-sm" data-testid={testid} />
  </label>
);

export const SiteSettingsCard = () => {
  const [s, setS] = useState({ feral_stays_url: "", brochure_url: "" });
  const [loaded, setLoaded] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    axios.get(`${API}/site-settings`).then((r) => { setS({ feral_stays_url: r.data.feral_stays_url || "", brochure_url: r.data.brochure_url || "" }); setLoaded(true); }).catch(() => setMsg("Could not load settings — refresh to try again."));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setMsg("");
    try {
      await axios.put(`${API}/admin/site-settings`, s, auth());
      setMsg("Saved.");
    } catch (err) {
      setMsg(err?.response?.data?.detail || "Could not save");
    }
  };

  return (
    <form onSubmit={save} className="bg-white border border-[#e0d3bf] rounded-lg p-4 mb-6 flex flex-col gap-3" data-testid="site-settings-card">
      <fieldset disabled={!loaded} className="contents">
      <Row label="FERAL Stays website" value={s.feral_stays_url} onChange={(v) => setS({ ...s, feral_stays_url: v })} placeholder="https://feralstays.com" testid="site-settings-stays-url" />
      <Row label="Venue hire brochure (PDF link)" value={s.brochure_url} onChange={(v) => setS({ ...s, brochure_url: v })} placeholder="https://… (empty = brochure form shows 'being finalised' message)" testid="site-settings-brochure-url" />
      <div className="flex items-center gap-3">
        <button className="bg-[#9b3d0a] text-white rounded-full px-4 py-2 text-xs font-semibold" data-testid="site-settings-save">Save</button>
        {msg && <span className="text-xs text-[#9b3d0a]" data-testid="site-settings-msg">{msg}</span>}
      </div>
      </fieldset>
    </form>
  );
};
